import { createApp  } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/** 引入公用样式*/
import '@/assets/base.scss'

/** 引入element-plus相关 */
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import * as ElIcons from '@element-plus/icons-vue'

import { Swipe, SwipeItem } from 'vant';
import { Collapse, CollapseItem } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { Overlay } from 'vant';
import { Dialog } from 'vant';
import { Search } from 'vant';
import { Notify } from 'vant';
import 'vant/lib/index.css';

/** vue应用实例 */
const app=createApp(App)

/** 全局注册ep图标 */
for(let iconName in ElIcons){
    app.component(iconName,ElIcons[iconName])
}
/** 使用插件 */
app.use(store)
app.use(router)
app.use(ElementPlus,{ locale: zhCn,})
app.use(Swipe);
app.use(SwipeItem);
app.use(Collapse);
app.use(CollapseItem);
app.use(Overlay);
app.use(Dialog);
app.use(Search);
app.use(DropdownMenu);
app.use(DropdownItem);
app.use(Notify);
/** 挂载 */
app.mount('#app')
